export default __webpack_public_path__ + "static/crotchet-635d5ca1b582aa0db91f8127c95e12f4.png";